export default "<span class=\"text-capitalize\" [ngClass]=\"className\">{{name}}</span>"